import React from 'react';

const heading = { fontFamily: "'Outfit', sans-serif" };

// About Precision Wealth. Used on the landing page and the in-app /about page.
export const AboutSection = ({ id = 'about-company' }) => (
  <section id={id} className="relative overflow-hidden py-24" style={{ backgroundColor: '#061530' }}>
    <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />
    <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full blur-3xl pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(192,151,92,0.10), transparent 70%)' }} />
    <div className="relative z-10 max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs font-semibold tracking-[0.3em] uppercase mb-3" style={{ color: '#C0975C' }}>About Precision Wealth</div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" style={heading}>
            Making money is your business. <span className="text-gradient-gold">Protecting it is ours.</span>
          </h2>
          <p className="text-[15px] leading-relaxed mb-4" style={{ color: '#94A9C9' }}>
            We remove the burden of financial planning and management by partnering with you to devise a customised, holistic financial plan that includes every area of your life, from wealth creation to wealth preservation and protection. Additionally, every structure we devise is stress-free, tax efficient and, most importantly, cost effective.
          </p>
          <p className="text-[15px] leading-relaxed" style={{ color: '#94A9C9' }}>
            Qualified, professional financial planners are available to help you achieve long-term financial goals through investments, tax and legal planning, asset allocation, risk management, retirement planning and estate planning for both you and your business. Local and offshore.
          </p>
        </div>
        <div className="grid grid-cols-2 grid-rows-2 gap-4 h-[460px]">
          <img src="/brand/office/office-1.webp" alt="Precision Wealth office" width={1179} height={1640} className="col-span-1 row-span-2 w-full h-full object-cover rounded-2xl" style={{ border: '1px solid #1D3D72' }} loading="lazy" />
          <img src="/brand/office/office-2.webp" alt="Precision Wealth lounge" width={1179} height={777} className="col-span-1 row-span-1 w-full h-full object-cover rounded-2xl" style={{ border: '1px solid #1D3D72' }} loading="lazy" />
          <img src="/brand/office/office-3.webp" alt="Precision Wealth meeting space" width={1179} height={1624} className="col-span-1 row-span-1 w-full h-full object-cover rounded-2xl" style={{ border: '1px solid #1D3D72' }} loading="lazy" />
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
